<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>
      <!-- Nome -->
      <d-col md="6" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorField('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Type -->
      <d-col md="3" class="form-group">
        <label for="feType">
          Tipo
          <small class="link" @click.prevent="addNewType()">
            Adicionar novo Tipo
          </small>
        </label>
        <d-select v-model="model.type" :state="hasErrorField('type_id')">
          <option
            :value="type"
            v-for="(type, index) in productType"
            :key="index"
          >
            {{ type.name }}
          </option>
        </d-select>
        <d-form-invalid-feedback>
          Tipo de produto é obrigatório
        </d-form-invalid-feedback>
      </d-col>

      <!-- Price -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Preço</label>
        <d-input-group prepend="R$">
          <input-currency
            :state="hasErrorField('price')"
            model-index="price"
            placeholder="Total"
            :model="model"
          />

          <d-form-invalid-feedback>
            Preço é obrigatório
          </d-form-invalid-feedback>
        </d-input-group>
      </d-col>

      <!-- Code -->
      <d-col :md="isAgentNoise ? 3 : 4" class="form-group" v-if="!isAgentVibration">
        <label for="code">{{ labelCode }}</label>
        <d-form-input
          type="text"
          id="code"
          :placeholder="labelCode"
          v-model="model.code"
        />
      </d-col>

      <!-- Method -->
      <d-col :md="isAgentNoise ? 3 : 4" class="form-group">
        <label for="method">{{ labelMethod }}</label>
        <d-form-input
          type="text"
          id="method"
          :placeholder="labelMethod"
          v-model="model.method"
        />
      </d-col>

      <!-- criterion -->
      <d-col md="4" class="form-group" v-if="isAgentVibration">
        <label for="criterion">
          Critério
        </label>
        <d-select
          type="text"
          id="criterion"
          class="form-control"
          v-model="model.criterion"
          required
        >
          <option value="AREN">AREN</option>
          <option value="AREN/VDVR">AREN/VDVR</option>
        </d-select>
      </d-col>

      <!-- Limit -->
      <d-col md="4" class="form-group" v-if="isAgentVibration">
        <label for="limit">Limite</label>
        <d-select
          type="text"
          id="limit"
          class="form-control"
          v-model="model.limit"
          required
        >
          <option value="null"></option>
          <option value="5m/s2">5m/s2</option>
          <option value="1,1 Aren / 21 VDVR">1,1 Aren / 21 VDVR</option>
        </d-select>
      </d-col>

      <template v-if="isAgentNoise">
        <d-col md="3" class="form-group">
          <label for="code_nr15">Código NR 15</label>
          <d-form-input
            id="code_nr15"
            v-model="model.code_nr15"
            placeholder="Código NR 15"
            type="text"
          />
        </d-col>

        <d-col md="3" class="form-group">
          <label for="method_nr15">Método NR 15</label>
          <d-form-input
            id="method_nr15"
            v-model="model.method_nr15"
            placeholder="Método NR 15"
            type="text"
          />
        </d-col>
      </template>

      <!-- cas -->
      <d-col md="4" class="form-group" v-if="model.type?.slug === 'chemical'">
        <label for="cas">
          CAS
          <i class="fas fa-info-circle p-0 fa-xs" id="tooltip-cas" />
          <d-tooltip target="#tooltip-cas" placement="top">
            Digite o número CAS (Chemical Abstracts Service)
          </d-tooltip>
        </label>
        <d-form-input
          type="text"
          id="cas"
          placeholder="Ex: 50-00-0"
          v-model="model.cas"
        />
      </d-col>

      <template v-if="isAgentChemical">
        <!-- Action in_body -->
        <d-col md="4" class="form-group">
          <label for="action_in_body">Ação no Organismo</label>
          <d-form-input
            type="text"
            id="action_in_body"
            placeholder="Ação no Organismo"
            v-model="model.action_in_body"
          />
        </d-col>

        <!-- Notion Skin -->
        <d-col md="4" class="form-group">
          <label for="notion_skin">Notações</label>
          <d-form-input
            type="text"
            id="notion_skin"
            placeholder="Notações"
            v-model="model.notion_skin"
          />
        </d-col>

        <!-- IPVS -->
        <d-col md="4" class="form-group">
          <label for="ipvs">IPVS <small>(PPM)</small></label>
          <d-form-input
            type="text"
            id="ipvs"
            placeholder="IPVS"
            v-model="model.ipvs"
          />
        </d-col>

        <!-- Odor limit -->
        <d-col md="4" class="form-group">
          <label for="odor_limit">Limite de odor <small>(PPM)</small></label>
          <d-form-input
            type="text"
            id="odor_limit"
            placeholder="Limite de odor"
            v-model="model.odor_limit"
          />
        </d-col>

        <!-- Respirator -->
        <d-col md="4" class="form-group">
          <label for="respirator">Respirador recomendado</label>
          <d-form-input
            type="text"
            id="respirator"
            placeholder="Respirador recomendado"
            v-model="model.respirator"
          />
        </d-col>
      </template>
    </d-form-row>

    <d-form-row v-if="model.id">
      <!-- Equipment -->
      <d-col md="12" class="form-group">
        <equipments
          :model.sync="model"
          :load-event="loadEquipment"
          :reload-event="reloadEquipment"
          :delete-event="deleteEquipment"
        />
      </d-col>
    </d-form-row>

    <add-type-option-modal />
    <add-equipment-modal
      :load-event="loadEquipment"
      :save-event="SAVE_EQUIPMENT_REQUEST"
      :reload-event="reloadEquipment"
      :search-event="SEARCH_EQUIPMENTS"
      :equipments-list="equipments"
    />
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import Events from '_utils/events';
import InputCurrency from '_shared/InputCurrency.vue';
import Equipments from '_shared/Equipments.vue';
import AddEquipmentModal from '_shared/AddEquipmentModal.vue';
import ProductService from '_services/rest/modules/product';
import { EQUIPMENT_DEFAULT } from '_constants/equipment';
import {
  MODEL,
  SAVE_EQUIPMENT_REQUEST,
  SEARCH_EQUIPMENTS,
  _DELETE_PRODUCT_EQUIPMENT_,
  _LOAD_EQUIPMENT_,
  _LOAD_MODEL_,
  _RELOAD_EQUIPMENT_,
  _RELOAD_TYPE_,
  _SAVE_PRODUCT_SUCCESS_,
} from './ProductModel';
import AddTypeOptionModal from './modal/AddTypeOptionModal.vue';

export default {
  name: 'product-form',
  mixins: [mixin, formatErrors],
  components: {
    Equipments,
    InputCurrency,
    AddTypeOptionModal,
    AddEquipmentModal,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
        price: { required: false },
        type_id: { required: false },
      },
      loadEquipment: _LOAD_EQUIPMENT_,
      reloadEquipment: _RELOAD_EQUIPMENT_,
      deleteEquipment: _DELETE_PRODUCT_EQUIPMENT_,
      SAVE_EQUIPMENT_REQUEST,
      SEARCH_EQUIPMENTS,
    };
  },
  computed: {
    equipments() {
      const { equipments } = this.$store.state.product;
      if (equipments && equipments.length) {
        return equipments;
      }
      return [];
    },
    productType() {
      const { productType } = this.$store.state.product;
      if (productType && productType.length) {
        return productType;
      }
      return [{ ...EQUIPMENT_DEFAULT }];
    },
    isAgentNoise() {
      return this.model.type?.slug === 'noise';
    },
    isAgentVibration() {
      return this.model.type?.slug === 'vibration';
    },
    isAgentChemical() {
      return this.model.type?.slug === 'chemical';
    },
    labelMethod() {
      return this.isAgentNoise ? 'Método NHO 01' : 'Método';
    },
    labelCode() {
      return this.isAgentNoise ? 'Código NHO 01' : 'Código';
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'setProduct',
      'activeAlert',
      'getEquipments',
      'getProductType',
    ]),
    addNewType() {
      this.setToggle({ type: 'add_type_option_modal', bool: true });
    },
    getOptions() {
      if (!this.$store.state.product.productType) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductType().then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
      }
      if (!this.$store.state.product.equipments) {
        this.setToggle({ type: 'progress', bool: true });
        this.getEquipments().then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
      }
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        this.model.type_id = this.model.type.id;
        ProductService.saveEntity(this.model, this.model.type.slug)
          .then(response => {
            this.success(response);
          })
          .catch(this.showError);
      }
      return null;
    },
    success(productSaved) {
      this.activeAlert({
        message: 'Produto salvo com sucesso',
        theme: 'success',
      });
      this.setProduct(productSaved);
      Events.$emit(_SAVE_PRODUCT_SUCCESS_, productSaved);
    },
    async handleSaveEquipment({ entityId, model }) {
      try {
        const response = await ProductService.saveEquipment(entityId, model);
        Events.$emit(_RELOAD_EQUIPMENT_, response);
        this.setToggle({ type: 'add_equipment_modal', bool: false });
      } catch (error) {
        this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
      }
    },
    handleSearchEquipments(query) {
      this.getEquipments(query);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
    Events.$on(_RELOAD_TYPE_, () => {
      this.getProductType();
    });
    this.getOptions();

    Events.$on(this.SAVE_EQUIPMENT_REQUEST, this.handleSaveEquipment);
    Events.$on(this.SEARCH_EQUIPMENTS, this.handleSearchEquipments);
  },
  beforeDestroy() {
    Events.$off(this.SAVE_EQUIPMENT_REQUEST, this.handleSaveEquipment);
    Events.$off(this.SEARCH_EQUIPMENTS, this.handleSearchEquipments);
  },
};
</script>

<style lang="scss" scoped>
@import "~_scss/overrides";

.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover {
    color: $green;
  }
  &.fa-minus:hover {
    color: $red;
  }
}
</style>
